import { gql } from 'src/__generated__'

export default gql(`
  mutation createComment($data: CreateCommentInput!) {
    createComment(data: $data) {
      id
    }
  }
`)
